import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import AdminSideMenu from "../../components/AdminSideMenu";

const AdminCarriersByIndustry = () => {
    const [carriers, setCarriers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [industry, setIndustry] = useState("");

    // Get industry from URL query
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const industryParam = searchParams.get("industry");

    useEffect(() => {
        // Set the industry from URL
        setIndustry(industryParam || "All Industries");
        // Fetch all carriers (or filter by industry if your API supports it)
        const fetchCarriers = async () => {
            try {
                const res = await axios.get("https://api.fleetycdl.com/api/carriers");
                const filtered = industryParam
                    ? res.data.filter((carrier) => carrier.industry === industryParam)
                    : res.data;

                setCarriers(filtered);
            } catch (error) {
                console.error("Failed to fetch carriers:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCarriers();
    }, [industryParam]);

    return (
        <div className="flex min-h-screen bg-gray-50">
            <AdminSideMenu />
            <div className="ml-64 min-h-screen w-full bg-gray-50">
                <h1 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800">
                    Carriers in {" "}
                    <span className="text-blue-600">{industry}</span> {" "}Industry
                </h1>

                {loading ? (
                    <div className="text-center py-10 text-gray-600">Loading...</div>
                ) : carriers.length === 0 ? (
                    <div className="text-center py-10 text-gray-600">
                        No carriers found for this industry.
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {carriers.map((carrier) => (
                            <div
                                key={carrier._id}
                                className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm transition-all duration-300 hover:shadow-md"
                            >
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {carrier.companyName}
                                    </h3>
                                    {carrier.companyLogo && (
                                        <img
                                            src={`https://api.fleetycdl.com/${carrier.companyLogo}`}
                                            alt={`${carrier.companyName} Logo`}
                                            className="w-12 h-12 object-contain rounded-lg"
                                        />
                                    )}
                                </div>
                                <div className="text-gray-600 mb-2">
                                    <i className="fas fa-industry mr-2"></i>
                                    {carrier.industry || "Not specified"}
                                </div>
                                <div className="text-gray-600 mb-2">
                                    <i className="fas fa-map-marker-alt mr-2"></i>
                                    {carrier.city}, {carrier.state}
                                </div>
                                <div className="text-gray-600 mb-2">
                                    <i className="fas fa-envelope mr-2"></i>
                                    {carrier.email}
                                </div>
                                <div className="text-gray-600 mb-2">
                                    <i className="fas fa-phone mr-2"></i>
                                    {carrier.phone}
                                </div>
                                <div className="flex flex-wrap gap-2 mt-3">
                                    {(carrier.tags || []).map((tag) => (
                                        <span
                                            key={tag}
                                            className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded"
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminCarriersByIndustry;
